var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AppPage,{attrs:{"title":"Bulk import shifts","subtitle":"Upload a file of recent time and attendance","icon":"calendar-circle-plus","previous":[{ label: 'Shifts', to: { name: 'shifts' } }]}},[_c(_setup.BulkUpload,{attrs:{"name":"shift","schema":_setup.FIELD_SCHEMA,"post-function":_setup.upload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }